import { Component, Input } from '@angular/core';

/** Standard page title block (Clinical Ease): section breadcrumb, headline, subtitle and a slot for actions. */
@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css',
  standalone: false,
})
export class PageHeaderComponent {
  @Input() title = '';
  @Input() subtitle = '';
  /** Module name shown in the breadcrumb, e.g. "Pharmacy". */
  @Input() section = '';
}
